import React from 'react';

interface FilePdfProps {
  className?: string;
}

export const FilePdf: React.FC<FilePdfProps> = ({ className = 'w-5 h-5' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
      <polyline points="14 2 14 8 20 8"></polyline>
      <path d="M9 15v-2h6v2"></path>
      <path d="M9 18v-2h6v2"></path>
      <path d="M9 12v-2h2v2"></path>
    </svg>
  );
};

export default FilePdf;
